import { render } from "./ListEcoles.vue?vue&type=template&id=9f09afe2"
import script from "./ListEcoles.vue?vue&type=script&lang=js"
export * from "./ListEcoles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__